import {
    collection,
    CollectionReference,
    DocumentData,
    Timestamp,
    getCountFromServer,
    doc,
    getDoc,
    updateDoc,
    deleteDoc,
    increment,
    arrayUnion
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { startAuthentication } from "@simplewebauthn/browser";
import { fs, functions } from "../firebase.ts";
import { getDeviceID } from "../components/global.ts";

export interface Post {
    id?: string; // doc id => b.333.eco/p/id
    date: Timestamp;
    author: string; // uid

    title: string;
    story: string; // plain text // no rich text bc copied to texting // optional: ""
    photo?: string; // url to storage // can be poster for short
    short?: string; // url to storage
    type: "photo" | "short" | "ai" | "none"; // media type: video/mp4 or image/jpeg // store type in file storage

    // TODO: later add more fields for all stamp types: see Chests
    //latitude: number;
    //longitude: number;
    //address: string; // human readable address

    // stats: from here
    digs?: number; // total digs
    diggers?: string[]; // device id of diggers
    miners?: string[]; // uid of miners

    // stats: b app
    previews?: number;
    crawlers?: Array<string>;
    scans?: number; // total scans
    scanners?: string[]; // device id of scanners
}

type Response = {
    text: string;
    color: "green" | "red" | "orange"; // status
    data?: Post;
};

export class Posts {
    private collection: CollectionReference<DocumentData>;

    constructor() {
        this.collection = collection(fs, "posts");
    }

    async count(): Promise<number> {
        const snapshot = await getCountFromServer(this.collection);
        return snapshot.data().count;
    }

    async get(id: string): Promise<Post | null> {
        const docRef = doc(fs, "posts", id);
        const docSnap = await getDoc(docRef);
        return docSnap.exists()
            ? ({ id: docSnap.id, ...docSnap.data() } as Post)
            : null;
    }

    async publish(
        title: string,
        story: string,
        photo: string,
        short: string,
        type: Post["type"]
    ): Promise<Response> {
        try {
            const getOpts = httpsCallable(functions, "getActionOptions");
            const options: any = (await getOpts({ action: "browser/post" }))
                .data;
            const assertion = await startAuthentication({
                optionsJSON: options
            });

            const verify = httpsCallable(functions, "verifyAction");
            const data = (
                await verify({
                    assertion,
                    action: "browser/post",
                    title,
                    story,
                    photo,
                    short,
                    type
                })
            ).data as Post;

            return {
                text: "Success",
                color: "green",
                data
            };
        } catch (error: any) {
            switch (error.name) {
                case "NotAllowedError":
                    return {
                        text: "Passkey verification was cancelled.",
                        color: "orange"
                    };
                default:
                    return { text: error.message, color: "red" };
            }
        }
    }

    async addMiner(uid: string, id: string) {
        const docRef = doc(fs, "posts", id);
        uid
            ? await updateDoc(docRef, {
                  digs: increment(1),
                  miners: arrayUnion(uid)
              })
            : await updateDoc(docRef, {
                  digs: increment(1),
                  diggers: arrayUnion(getDeviceID())
              });
    }

    // not allowed bc blockchain
    async remove(id: string) {
        const docRef = doc(fs, "posts", id);
        await deleteDoc(docRef);
    }
}
